import { render } from "./FlowMeta.vue?vue&type=template&id=1ca62816"
import script from "./FlowMeta.vue?vue&type=script&lang=js"
export * from "./FlowMeta.vue?vue&type=script&lang=js"

import "./FlowMeta.vue?vue&type=style&index=0&id=1ca62816&lang=css"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__